module.exports = __webpack_public_path__ + "static/bi-slider2-96ed7097d7090a743838f9f5e53dda24.jpeg";